export const env = {
    API_URL: 'https://app.chibakenkita.com/v1'
}